module.exports = __webpack_public_path__ + "img/yes.5af3c71d.png";